module.exports = __webpack_public_path__ + "images/application/badge-email-single@2x-ec21ac3d.png";